import { defineStore } from "pinia";

export const useMainStore = defineStore("main", {
  state: () => ({
    ct: "",
    ut: "",
    uid: "",
    deviceid: "", // 安卓 euid, ios idfv 
     
    haslogin: false,
    hasSecurities: false, // 是否绑定证券
    hasAuth: false, // 是否微信授权成功
    jfTaskList: [],
    totalGameResult: 0,
    actEnd: false,
    userObj: {} as Record<string, any>,
    configObj: {} as Record<string, any>,
    activatedTime: 0, // 激活时间戳

    companyInfo:{},
    inviteTaskItem:{},
    shareTaskItem:{},
    shareid: "", // 分享id
 

    scratchPrizeInfo:{},
    card5PrizeInfo:[], 

  }),
  actions: {
    setUserInfo(obj: any) {
      this.$patch(obj);
    },
  },
  getters: {
    getUserObj: (state) => () => state.userObj,
  },
});
